import { EventEmitter, Injectable } from '@angular/core';
import { MatSelect } from '@angular/material/select';
import { Router } from '@angular/router';
import { NotifierService } from 'angular-notifier';
import { ApiRequestService } from 'src/app/services/api-request/api-request.service';

@Injectable({
  providedIn: 'root'
})
export class QaReportService {
  public isOpen: boolean = false;
  public isLoading: boolean = false;
  public qaReportResult:any = {}
  public qaReportJson:any = {}
  public qaReportGridJson:any = {}
  public rowGroupLevel:number = 1;
  public initSideDrawerEvent = new EventEmitter<string>();
  // public initDefaultSheetSelectionEvent = new EventEmitter<string>();
  public initQaDashBoardConfigEmitter = new EventEmitter<any>();
  public initQaDashBoardEmitter = new EventEmitter<any>();
  public initSubGraphsEmitter = new EventEmitter<any>();
  
  public isGridFilter:boolean = false;
  public gridHeaderJson:any = []
  public gridHeadParentSpliter:string = '#';
  public startDate:any;
  public endDate:any;
  public startMonth:any;
  public endMonth:any;

  public treeGridFilters:any ={};
  public treeGridFiltersArr:any ={};
  public gridTreeFilters:any ={};
  public gridTreeFilterCopy:any ={};
  public gridOtherFilters:any ={};
  public gridFrequencyFilters:any ={};
  public gridFilters:any ={};
  public gridTabFilters:any ={};

  public reportFilters:any =[];
  public reportFiltersCopy:any =[];


  // public gridFiltersCopy:any ={};

  public appliedFilter:any = {};
  public copyappliedFilter:any = {};
  public qaReportConfig:any = {};
  public qaDashboardConfig:any = {};
  public isNoTableFound:boolean = false;
  public isLoadingGridData:boolean = false;
  

  public page = 1;
  public page_size = 20;
  public serachBy:string = "";
  public bufferArr:any = [];
  public sortby:string="";
  public gridDataContainer:any[] = [];

  public selectedSheet = {};
  public selectedTab = {};
  public isZoneLevel:boolean = true;
  public defaultGraphFrequency = 'year';
  public defaultReportDate = {startDate:0,endDate:0};
  // public graphLineColors:string[] = ["#91989e","#4e60b2","#8aa5d2","#cb3956","#bf646b","#965da1","#007d6c","#74638b","#9aa386","#aa81a1","#86a39f","#f0dede","#f99a86"]
  // public graphLineColors:string[] = ["#074e8c","#4ad8be","#2f65d1","#003058","#ffa700","#ebb5cc"]
  public graphLineColors:string[] = ["#074e8c","#4ad8be","#2f65d1","#003058","#f5d23a","#ebb5cc"]
  constructor(public notifier:NotifierService,private apiRequest: ApiRequestService,private router: Router) { 
    // this.startMonth = new Date() 
  }
  parseGridData(data){
    var newGridData = [];
    let selectedRowGroup = {};
    data.forEach(rowObj => {
      let newRowObj={}
      Object.keys(this.qaReportResult['headers']).forEach(headKey => {
        if (headKey == 'row') {
          let rowName = rowObj[headKey] + '';
          let tempRowGroupArr = rowName.split('#');
          let parent = "";
          let totalPointer = "";
          tempRowGroupArr.forEach((rowValue, rIndex) => {
            parent = rIndex > 0 ? parent +'#'+ rowValue : parent + rowValue;
            let totalPointerRowValue = rowValue == "Total" ? "zzzzz_"+rowValue : rowValue;
            totalPointer = rIndex > 0 ? totalPointer +'#'+ totalPointerRowValue : totalPointer + totalPointerRowValue;
            
            selectedRowGroup["level_"+rIndex] = selectedRowGroup["level_"+rIndex] ? selectedRowGroup["level_"+rIndex] : [];
            let rowKey = rIndex > 0 ? "row_"+rIndex : "row";
            if (selectedRowGroup["level_"+rIndex].some(item => item.parent === parent && item.key === rowValue)) {
              newRowObj[rowKey] = ''
            }else{
              newRowObj[rowKey] = rowValue == "OverallTotal" ||  rowValue == "NationalTotal" ? "Total" : rowValue;
              newRowObj[rowKey+"_toolTip"] = rowValue == "OverallTotal" ? "Total" : rowValue;
              selectedRowGroup["level_"+rIndex].push({"parent":parent,"key":rowValue})
            }
          });
          newRowObj["pPath"] = rowObj[headKey];
          newRowObj["totalPointer"] = totalPointer;
          // newRowObj[this.qaReportResult['headers'][headKey]['name']] = rowObj[this.qaReportResult['headers'][headKey]['name']] ? rowObj[this.qaReportResult['headers'][headKey]['name']] : '-'
        }else{
          newRowObj[headKey] = rowObj[headKey] ? rowObj[headKey] : '-'
          newRowObj[headKey+"_toolTip"] = rowObj[headKey] ? rowObj[headKey] : '-'
        }
      });
      newGridData.push(newRowObj);

    });
    // console.log("selectedRowGroup ===. ",selectedRowGroup)
    newGridData = newGridData.sort((a, b) => {
      // if (a.totalPointer === "Overall") return 1;  // "Overall" should come last
      // if (b.totalPointer === "Overall") return -1; // "Overall" should come last
      if (a.totalPointer === "Overall") return 1;  // "Overall" should come last
      if (b.totalPointer === "Overall") return -1; // "Overall" should come last
      if (a.totalPointer === "OverallTotal") return 1;  // "Overall" should come last
      if (b.totalPointer === "OverallTotal") return -1; // "Overall" should come last
      if (a.totalPointer === "National") return 1;  // "Overall" should come last
      if (b.totalPointer === "National") return -1; 
      return a.totalPointer.localeCompare(b.totalPointer); // Standard lexicographic sorting for pPath
    });
    return newGridData;
  }

  parseGridHeader(data) {
    const headers = {};
      for (const key in data) {
        const [headerKey, column] = key.split('#');
        // console.log("headerKey => ",headerKey," column => ",column)
        if (!headers[headerKey]) {
          if (headerKey == "row") {
            let rowName = data[key]['name'] + '';
            let tempRowGroupArr = rowName.split('#');
            this.rowGroupLevel = tempRowGroupArr.length;
            tempRowGroupArr.forEach((rowCount, rIndex) => {
              let rowKey = rIndex > 0 ? "row_"+rIndex : "row"
              headers[rowKey] = {
                headerKey:rowKey,
                headerName: rowCount == "row" ? "" : rowCount,
              // headerName:"",
              priority:data[key]['priority'],
              field:rowKey,
              minWidth: 80, 
              tooltipField:rowKey+"_toolTip",
              pinned: 'left'
            };
            headers[rowKey].cellClass = (params) => {
              return this.addCellClass(params,key);
            };
            });
            // headers[headerKey] = {
            //   headerKey,
            //   headerName: headerKey == "row" ? "" : headerKey,
            //   priority:data[key]['priority'],
            //   pinned: 'left'
            // };
          }else{
            headers[headerKey] = {
              headerKey,
              headerName: headerKey == "row" ? "" : headerKey,
              priority:data[key]['priority']
            };
          }
          // headers[headerKey] = {
          //   headerKey,
          //   headerName: headerKey == "row" ? "" : headerKey,
          //   priority:data[key]['priority']
          // };
          // if (headerKey == "row") {
          //   headers[headerKey]['pinned'] = 'left'
          // }
          if (column && column !='') {
            headers[headerKey]['children'] = [];
          }else{
            headers[headerKey]['field'] = headerKey;
            headers[headerKey]['minWidth']= 80, 
            headers[headerKey]['tooltipField'] = key+"_toolTip";
            // headers[headerKey]['sortable'] = true;
            headers[headerKey].cellStyle = (params) => {
              return this.addCellStyle(params,key);
            };
            headers[headerKey].cellClass = (params) => {
              return this.addCellClass(params,key);
            };
          }
        }
        if (column && column !='') {
            headers[headerKey].children.push({
              field: key,
              headerKey: column,
              headerName: column,
              minWidth: 80, 
              tooltipField:key+"_toolTip",
              cellStyle : (params) => {
                return this.addCellStyle(params,key);
              },
              cellClass:(params) =>{
                return this.addCellClass(params,key);
              }
            });

            headers[headerKey].children = this.sortHeaders(headers[headerKey].children);
        }
      }
  
    // Convert the grouped headers to an array
    let sortedHeaders = Object.values(headers);
    sortedHeaders =  sortedHeaders.sort((a:any, b:any) => a.priority - b.priority);
    return sortedHeaders;
  }

  sortHeaders(headers){
    const sortedData = headers.sort((a, b) => {
      const includesVsA = a.field.includes("vs");
      const includesVsB = b.field.includes("vs");
    
      // Sort based on whether 'vs' is included
      if (includesVsA === includesVsB) {
        return a.field.localeCompare(b.field); // If both are the same, sort by field name
      }
    
      return includesVsA ? 1 : -1; // Place those that include "vs" after those that don't
    });

    return sortedData;
  }
 

  addCellStyle(params,pPath?){
    let style = {};
    let cell = pPath.split("#") && pPath.split("#").at(-1) ? pPath.split("#").at(-1) : pPath;
    if (cell && cell.split(" ") && cell.split(" ")[0]  && cell.split(" ")[0] == 'vs') {
      params.node.data[pPath] = params.node.data[pPath]+""
      let number = parseFloat(params.node.data[pPath].replace('%', ''));
      if (number > 0) {
        // style['color'] = '#037603';
        style['color'] = '#fa0303';
      }else if (number < 0) {
        style['color'] = '#037603';
      }
    }
    if(this.selectedTab && this.selectedTab['grid_style']  && this.selectedTab['grid_style'][cell.toLowerCase()]){
      let number = parseFloat(params.node.data[pPath]);
      if (number < this.selectedTab['grid_style'][cell.toLowerCase()]['check_point']) {
        style['background-color'] = this.selectedTab['grid_style'][cell.toLowerCase()]['lessthan_bg'];
        style['color'] = this.selectedTab['grid_style'][cell.toLowerCase()]['lessthan_color'];
      }else if (number == this.selectedTab['grid_style'][cell.toLowerCase()]['check_point']) {
        style['background-color'] = this.selectedTab['grid_style'][cell.toLowerCase()]['equalto_bg'];
        style['color'] = this.selectedTab['grid_style'][cell.toLowerCase()]['equalto_color'];
      } else if (number > this.selectedTab['grid_style'][cell.toLowerCase()]['check_point']) {
        style['background-color'] = this.selectedTab['grid_style'][cell.toLowerCase()]['greaterthan_bg'];
        style['color'] = this.selectedTab['grid_style'][cell.toLowerCase()]['greaterthan_color'];
      }
        
    }

    return style;
  }

  addCellClass(params,pPath){
    let className = "";
    let totalKey = "Total";
    // if(params.node.data['row'] && params.node.data['row'] == 'Overall'){
    //   className += 'bold-row ';
    // }
    if ((params.node.data['row'] && params.node.data['row'] == 'Overall') || (params.node.data['row'] && params.node.data['row'] == 'National') || (params.node.data['row'] && params.node.data['row'] == totalKey) || (params.node.data['row_1'] && params.node.data['row_1'] == totalKey) || (params.node.data['row_2'] && params.node.data['row_2'] == totalKey) || (params.node.data['row_3'] && params.node.data['row_3'] == totalKey) || (params.node.data['row_4'] && params.node.data['row_4'] == totalKey)) {
      className += 'bold-row ';
    }
    return className;
  }


  callQaDashBoardData(body){
    return this.apiRequest.request('POST','/v2/qadashboard/getData',body);
  }


  // getQaDashBoardData(body){
  //   this.callQaDashBoardData(body).subscribe(data => {
  //     if(data['status'] == 1){
  //       this.initQaDashBoardEmitter.emit(data['result']);
  //     }else{
  //       this.notifier.notify("error",'Something went wrong');
  //     }
  //   });
  // }

  // getQaDashboardSubgraph(body){
  //   this.callQaDashBoardData(body).subscribe(data => {
  //     if(data['status'] == 1){
  //       this.initSubGraphsEmitter.emit(data['result']);
  //     }else{
  //       this.notifier.notify("error",'Something went wrong');
  //     }
  //   });
  // }

  setDate(filter){
    Object.keys(filter).forEach(va =>{
      if(filter[va][0]['type'] == 'calendar'){
        let start_date = filter[va][0]['start_date'];
        let end_date = filter[va][0]['end_date'];
        if(start_date && end_date){
          this.startDate = new Date(start_date);
          this.endDate = new Date(end_date);
        }
        return;
      }
    })
  }

  resetReportGrid(){
    this.startDate = '';
    this.endDate = '';
    this.serachBy = "";
    this.page = 1;
    this.page_size = 20;
  }
  // setTabFilters(){
  //   this.gridTabFilters = this.selectedTab['filters'] ? JSON.parse(JSON.stringify(this.selectedTab['filters'])) : {};
  //   let year_filters={}
  //   if (Object.keys(this.gridTabFilters).includes('frequency')) {
  //     Object.values(this.gridTabFilters['frequency']).forEach((freq, index) => {
  //       if(freq['selected']){
  //         year_filters = freq['year_filters']
  //         this.defaultGraphFrequency = freq['value'];
  //         this.appliedFilter["frequency"] = [freq['value']];
  //       }
  //     })
  //   }else if (this.selectedTab['year_filters']) {
  //     year_filters = this.selectedTab['year_filters'];
  //   }


  //   if (year_filters && Object.keys(year_filters).length > 0) {
  //     Object.keys(year_filters).forEach(key => {
  //       // let yearFilter = this.qaDashboardConfig['filters'][year_filters[key]]
  //       this.gridTabFilters[key] = this.qaDashboardConfig['filters'][year_filters[key]];
  //       // this.yearFilter[this.yearFilter.length - 1]['value']
  //     });
  //   }
  // }

  setTabFilters(){
    this.gridTabFilters = this.selectedTab['filters'] ? JSON.parse(JSON.stringify(this.selectedTab['filters'])) : {};
    let year_filters={}
    let frequency_year_filters={}
    let isFrequencyFilterAvailable = false;
    if (Object.keys(this.gridTabFilters).includes('frequency')) {
      // year_filters={
      //   "from": "year",
      //   "to": "year",
      //   "month": {
      //     "0": {
      //       "label": "January",
      //       "key": "month",
      //       "value": "january",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "01-01  00:00:00",
      //       "end": "01-31  23:59:59"
      //     },
      //     "1": {
      //       "label": "February",
      //       "key": "month",
      //       "value": "february",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "02-01  00:00:00",
      //       "end": "02-28  23:59:59"
      //     },
      //     "2": {
      //       "label": "March",
      //       "key": "month",
      //       "value": "march",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "03-01  00:00:00",
      //       "end": "03-31  23:59:59"
      //     },
      //     "3": {
      //       "label": "April",
      //       "key": "month",
      //       "value": "april",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "04-01  00:00:00",
      //       "end": "04-30  23:59:59"
      //     },
      //     "4": {
      //       "label": "May",
      //       "key": "month",
      //       "value": "may",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "05-01  00:00:00",
      //       "end": "05-31  23:59:59"
      //     },
      //     "5": {
      //       "label": "June",
      //       "key": "month",
      //       "value": "june",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "06-01  00:00:00",
      //       "end": "06-30  23:59:59"
      //     },
      //     "6": {
      //       "label": "July",
      //       "key": "month",
      //       "value": "july",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "07-01  00:00:00",
      //       "end": "07-31  23:59:59"
      //     },
      //     "7": {
      //       "label": "August",
      //       "key": "month",
      //       "value": "august",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "08-01  00:00:00",
      //       "end": "08-31  23:59:59"
      //     },
      //     "8": {
      //       "label": "September",
      //       "key": "month",
      //       "value": "sepetember",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "09-01  00:00:00",
      //       "end": "09-30  23:59:59"
      //     },
      //     "9": {
      //       "label": "October",
      //       "key": "month",
      //       "value": "october",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "10-01  00:00:00",
      //       "end": "10-31  23:59:59"
      //     },
      //     "10": {
      //       "label": "November",
      //       "key": "month",
      //       "value": "november",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "11-01  00:00:00",
      //       "end": "11-30  23:59:59"
      //     },
      //     "11": {
      //       "label": "December",
      //       "key": "month",
      //       "value": "december",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "12-01  00:00:00",
      //       "end": "12-31  23:59:59"
      //     }
      //   },
      //   "quarter": {
      //     "0": {
      //       "label": "Q1",
      //       "key": "quarter",
      //       "value": "Q1",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "01-01  00:00:00",
      //       "end": "03-31  23:59:59"
      //     },
      //     "1": {
      //       "label": "Q2",
      //       "key": "quarter",
      //       "value": "Q2",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "04-01  00:00:00",
      //       "end": "06-30  23:59:59"
      //     },
      //     "2": {
      //       "label": "Q3",
      //       "key": "quarter",
      //       "value": "Q3",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "07-01  00:00:00",
      //       "end": "09-30  23:59:59"
      //     },
      //     "3": {
      //       "label": "Q4",
      //       "key": "quarter",
      //       "value": "Q4",
      //       "type": "radio",
      //       "selection": "string",
      //       "start": "10-01  00:00:00",
      //       "end": "12-31  23:59:59"
      //     }
      //   }
      // }
      year_filters = this.selectedTab['year_filters']
      isFrequencyFilterAvailable = true;
      Object.values(this.gridTabFilters['frequency']).forEach((freq, index) => {
        if(freq['selected']){
          // year_filters = freq['year_filters']
          frequency_year_filters = freq['year_filters']
          this.defaultGraphFrequency = freq['value'];
          this.appliedFilter["frequency"] = [freq['value']];
        }
      })
    }else if (this.selectedTab['year_filters']) {
      year_filters = this.selectedTab['year_filters'];
    }

    if (year_filters && Object.keys(year_filters).length > 0) {
      Object.keys(year_filters).forEach(key => {
        if (key == 'from' || key == 'to') {
          this.gridTabFilters[key] = this.qaDashboardConfig['filters'][year_filters[key]];
          this.gridTabFilters[key][0]["visibility"] = isFrequencyFilterAvailable ? (frequency_year_filters && frequency_year_filters[key]) ? "visible" : "hidden" : "visible";
          // this.gridTabFilters[key][0]["visibility"] = isFrequencyFilterAvailable ? (frequency_year_filters && frequency_year_filters[key]) ? "visible" : "visible" : "visible";
        }else{
          this.gridTabFilters[key] = year_filters[key];
          this.gridTabFilters[key][0]["visibility"] = isFrequencyFilterAvailable ? (frequency_year_filters && frequency_year_filters[key]) ? "visible" : "hidden" : "visible";
          // this.gridTabFilters[key][0]["visibility"] = isFrequencyFilterAvailable ? (frequency_year_filters && frequency_year_filters[key]) ? "visible" : "visible" : "visible";
        }
      });
    }
  }

  getReportGrid(body){
    this.getReportGridApi(body).subscribe(data => {
      if(data['status'] == 1){
        this.qaReportResult = data['result'];
        this.qaReportJson = data['result']['data'];
        // this.gridFilters = data['result']['filters'];
        // let headers = this.parseGridHeader(this.qaReportJson[0]);
        let headers = this.parseGridHeader(this.qaReportResult['headers']);
        // this.gridFilters = this.selectedTab['filters'] ? JSON.parse(JSON.stringify(this.selectedTab['filters'])) : {};
        this.gridFilters = (this.gridTabFilters && Object.keys(this.gridTabFilters).length) ? JSON.parse(JSON.stringify(this.gridTabFilters)) : {};
        // this.setTabFilters();
        Object.keys(data['result']['filters']).forEach(key => {
          this.gridFilters[key] = data['result']['filters'][key];
        });
        // console.log(`this.gridFilters`, this.gridFilters);
        this.transformData(this.gridFilters);
        // this.inittempFilter();
        this.isGridFilter = Object.keys(this.gridFilters).length > 0 ? true : false;
        this.qaReportJson = this.qaReportJson.sort((a, b) => {
          if (a.row === "Overall") return 1;  // "Overall" should come last
          if (b.row === "Overall") return -1; // "Overall" should come last
          return a.row.localeCompare(b.row); // Standard lexicographic sorting for pPath
        });
        let gridData = this.parseGridData(this.qaReportJson);
        this.qaReportGridJson = {"headers":headers,"data": gridData}
        this.isNoTableFound = false;
        this.isLoadingGridData = false;
      }else{
        this.isLoadingGridData = false;
        this.isNoTableFound = true;
        this.notifier.notify("error",'Something went wrong');
      }
    });

    // console.log(" this.appliedFilter data is ===> ",this.appliedFilter)
  }

  getReportGridApi(body){
    return this.apiRequest.request('POST','/v2/qadashboard/getData',body);
  }

  getQaReportConfig(){
    return this.apiRequest.request('POST','/v2/qadashboard/getConfig',{});
  }

  // dummyConfig(){
  //   let data = {
  //     "result": {
  //       "file_config": [
  //         {
  //           "name": "Rejection on YoY",
  //           "sheet_key": "rejection-on-yoy",
  //           "priority": 1,
  //           "tabs": [
  //             {
  //               "name": "Zone",
  //               "priority": 1,
  //               "tab_key": "rejection-on-zone",
  //               "req_body": {
  //                 "groups": [
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "year",
  //                       "base_zone",
  //                       "total_count",
  //                       "count_total"
  //                     ],
  //                     "order": [
  //                       "year"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "year",
  //                         "total_count",
  //                         "count_total"
  //                       ]
  //                     }
  //                   },
  //                   {
  //                     "data_from": "master_data_clt",
  //                     "group": [
  //                       "year",
  //                       "base_zone",
  //                       "total_count",
  //                       "count_total"
  //                     ],
  //                     "order": [
  //                       "year"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "year",
  //                         "total_count",
  //                         "count_total"
  //                       ]
  //                     }
  //                   }
  //                 ],
  //                 "trend": {
  //                   "compare_year": "all"
  //                 },
  //                 "col": "year",
  //                 "row": "zone",
  //                 "percentage": [
  //                   "all"
  //                 ],
  //                 "overall": {
  //                   "group": [
  //                     "year"
  //                   ],
  //                   "name": "National"
  //                 },
  //                 "formulas": [
  //                   {
  //                     "formula": [
  //                       "value",
  //                       "{{value}}#Total"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": false,
  //                     "type": "col"
  //                   }
  //                 ],
  //                 "hide_col": [
  //                   "#Total"
  //                 ]
  //               },
  //               "filters": {},
  //               "year_filters": {
  //                 "from": "year",
  //                 "to": "year"
  //               },
  //               "default_year_range": 3,
  //               "grid_style": {}
  //             },
  //             {
  //               "name": "Office",
  //               "priority": 2,
  //               "tab_key": "rejection-on-office",
  //               "req_body": {
  //                 "groups": [
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "year",
  //                       "office",
  //                       "total_count",
  //                       "count_total"
  //                     ],
  //                     "order": [
  //                       "year"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "year",
  //                         "total_count",
  //                         "count_total"
  //                       ]
  //                     }
  //                   },
  //                   {
  //                     "data_from": "master_data_clt",
  //                     "group": [
  //                       "year",
  //                       "office",
  //                       "total_count",
  //                       "count_total"
  //                     ],
  //                     "order": [
  //                       "year"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "year",
  //                         "total_count",
  //                         "count_total"
  //                       ]
  //                     }
  //                   }
  //                 ],
  //                 "percentage": [
  //                   "all"
  //                 ],
  //                 "formulas": [
  //                   {
  //                     "formula": [
  //                       "value",
  //                       "{{value}}#Total"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": false,
  //                     "type": "col"
  //                   }
  //                 ],
  //                 "hide_col": [
  //                   "#Total"
  //                 ],
  //                 "trend": {
  //                   "compare_year": "all"
  //                 },
  //                 "overall": "National",
  //                 "row": "office",
  //                 "col": "year"
  //               },
  //               "filters": {},
  //               "year_filters": {
  //                 "from": "year",
  //                 "to": "year"
  //               },
  //               "default_year_range": 0,
  //               "grid_style": {}
  //             }
  //           ]
  //         },
  //         {
  //           "name": "Rejection on QoQ",
  //           "sheet_key": "rejection-on-qoq",
  //           "priority": 2,
  //           "tabs": [
  //             {
  //               "name": "Zone",
  //               "priority": 1,
  //               "tab_key": "rejection-on-zone",
  //               "req_body": {
  //                 "groups": [
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "quarter",
  //                       "base_zone",
  //                       "total_count",
  //                       "quarter_total"
  //                     ],
  //                     "order": [
  //                       "quarter"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "quarter",
  //                         "total_count",
  //                         "quarter_total"
  //                       ]
  //                     }
  //                   },
  //                   {
  //                     "data_from": "master_data_clt",
  //                     "group": [
  //                       "quarter",
  //                       "base_zone",
  //                       "total_count",
  //                       "quarter_total"
  //                     ],
  //                     "order": [
  //                       "quarter"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "quarter",
  //                         "total_count",
  //                         "quarter_total"
  //                       ]
  //                     }
  //                   }
  //                 ],
  //                 "row": "zone",
  //                 "col": "quarter",
  //                 "trend": {
  //                   "compare_year": "all"
  //                 },
  //                 "percentage": [
  //                   "all"
  //                 ],
  //                 "formulas": [
  //                   {
  //                     "formula": [
  //                       "value",
  //                       "{{value}}#Total"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": false,
  //                     "type": "col"
  //                   }
  //                 ],
  //                 "hide_col": [
  //                   "#Total"
  //                 ],
  //                 "overall": "National"
  //               },
  //               "filters": {},
  //               "year_filters": {
  //                 "from": "year",
  //                 "to": "year"
  //               },
  //               "default_year_range": 3,
  //               "grid_style": {}
  //             },
  //             {
  //               "name": "Office",
  //               "priority": 2,
  //               "tab_key": "rejection-on-office",
  //               "req_body": {
  //                 "groups": [
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "quarter",
  //                       "office",
  //                       "total_count",
  //                       "quarter_total"
  //                     ],
  //                     "order": [
  //                       "quarter"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "quarter",
  //                         "total_count",
  //                         "quarter_total"
  //                       ]
  //                     }
  //                   },
  //                   {
  //                     "data_from": "master_data_clt",
  //                     "group": [
  //                       "quarter",
  //                       "office",
  //                       "total_count",
  //                       "quarter_total"
  //                     ],
  //                     "order": [
  //                       "quarter"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "quarter",
  //                         "total_count",
  //                         "quarter_total"
  //                       ]
  //                     }
  //                   }
  //                 ],
  //                 "row": "office",
  //                 "col": "quarter",
  //                 "qa_type": "report",
  //                 "trend": {
  //                   "compare_year": "all"
  //                 },
  //                 "percentage": [
  //                   "all"
  //                 ],
  //                 "formulas": [
  //                   {
  //                     "formula": [
  //                       "value",
  //                       "{{value}}#Total"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": false,
  //                     "type": "col"
  //                   }
  //                 ],
  //                 "hide_col": [
  //                   "#Total"
  //                 ],
  //                 "overall": "National"
  //               },
  //               "filters": {},
  //               "year_filters": {
  //                 "from": "year",
  //                 "to": "year"
  //               },
  //               "default_year_range": 3,
  //               "grid_style": {}
  //             }
  //           ]
  //         },
  //         {
  //           "name": "Rejection by Field",
  //           "sheet_key": "rejection-by-field",
  //           "priority": 3,
  //           "tabs": [
  //             {
  //               "name": "Rejection By Zone",
  //               "priority": 1,
  //               "tab_key": "rejection-by-zone",
  //               "req_body": {
  //                 "groups": [
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field",
  //                       "{{frequency}}_base",
  //                       "{{frequency}}_rejection %",
  //                       "{{frequency}}_rejection %_total"
  //                     ],
  //                     "order": [
  //                       "{{frequency}}"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "{{frequency}}_base",
  //                         "{{frequency}}_rejection %",
  //                         "{{frequency}}_rejection %_total"
  //                       ],
  //                       "ignore_filters": [
  //                         "zone_field"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "{{frequency}}_base",
  //                           "{{frequency}}_rejection %",
  //                           "{{frequency}}_rejection %_total"
  //                         ],
  //                         "row": "Zone#Total",
  //                         "ignore_filters": [
  //                           "zone_field"
  //                         ],
  //                         "add_split_filters": [
  //                           {
  //                             "name": "zone_field",
  //                             "new_filter": "zone",
  //                             "index": 0,
  //                             "split": "#"
  //                           }
  //                         ]
  //                       }
  //                     ]
  //                   },
  //                   {
  //                     "data_from": "master_data_clt",
  //                     "group": [
  //                       "zone_field",
  //                       "{{frequency}}_base",
  //                       "{{frequency}}_rejection %",
  //                       "{{frequency}}_rejection %_total"
  //                     ],
  //                     "order": [
  //                       "{{frequency}}"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "{{frequency}}_base",
  //                         "{{frequency}}_rejection %",
  //                         "{{frequency}}_rejection %_total"
  //                       ],
  //                       "ignore_filters": [
  //                         "zone_field"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "{{frequency}}_base",
  //                           "{{frequency}}_rejection %",
  //                           "{{frequency}}_rejection %_total"
  //                         ],
  //                         "row": "Zone#Total",
  //                         "ignore_filters": [
  //                           "zone_field"
  //                         ],
  //                         "add_split_filters": [
  //                           {
  //                             "name": "zone_field",
  //                             "new_filter": "zone",
  //                             "index": 0,
  //                             "split": "#"
  //                           }
  //                         ]
  //                       }
  //                     ]
  //                   }
  //                 ],
  //                 "row": "Zone#Field Office",
  //                 "col": "",
  //                 "percentage": [
  //                   "Rejection %"
  //                 ],
  //                 "formulas": [
  //                   {
  //                     "formula": [
  //                       "value",
  //                       "{{value}}#Total"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": false,
  //                     "type": "col"
  //                   }
  //                 ],
  //                 "hide_col": [
  //                   "#Total"
  //                 ],
  //                 "trend": {
  //                   "compare_year": 1,
  //                   "col": "Rejection %"
  //                 },
  //                 "required_filters": {
  //                   "Office": {
  //                     "name": "zone_field",
  //                     "type": "tree"
  //                   }
  //                 }
  //               },
  //               "filters": {
  //                 "frequency": {
  //                   "0": {
  //                     "label": "Yearly",
  //                     "key": "frequency",
  //                     "value": "Year",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "to": "year"
  //                     },
  //                     "selected": true,
  //                     "default_year_range": 0
  //                   },
  //                   "1": {
  //                     "label": "Quarterly",
  //                     "key": "frequency",
  //                     "value": "Quarter",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year"
  //                     },
  //                     "default_year_range": 0
  //                   },
  //                   "2": {
  //                     "label": "Monthly",
  //                     "key": "frequency",
  //                     "value": "Month",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year"
  //                     },
  //                     "default_year_range": 0
  //                   }
  //                 }
  //               },
  //               "year_filters": {
  //                 "from": "year",
  //                 "to": "year",
  //                 "month": {
  //                   "0": {
  //                     "label": "January",
  //                     "key": "month",
  //                     "value": "january",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "01-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "February",
  //                     "key": "month",
  //                     "value": "february",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "02-01  00:00:00",
  //                     "end": "02-28  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "March",
  //                     "key": "month",
  //                     "value": "march",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "03-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "April",
  //                     "key": "month",
  //                     "value": "april",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "04-30  23:59:59"
  //                   },
  //                   "4": {
  //                     "label": "May",
  //                     "key": "month",
  //                     "value": "may",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "05-01  00:00:00",
  //                     "end": "05-31  23:59:59"
  //                   },
  //                   "5": {
  //                     "label": "June",
  //                     "key": "month",
  //                     "value": "june",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "06-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "6": {
  //                     "label": "July",
  //                     "key": "month",
  //                     "value": "july",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "07-31  23:59:59"
  //                   },
  //                   "7": {
  //                     "label": "August",
  //                     "key": "month",
  //                     "value": "august",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "08-01  00:00:00",
  //                     "end": "08-31  23:59:59"
  //                   },
  //                   "8": {
  //                     "label": "September",
  //                     "key": "month",
  //                     "value": "sepetember",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "09-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "9": {
  //                     "label": "October",
  //                     "key": "month",
  //                     "value": "october",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "10-31  23:59:59"
  //                   },
  //                   "10": {
  //                     "label": "November",
  //                     "key": "month",
  //                     "value": "november",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "11-01  00:00:00",
  //                     "end": "11-30  23:59:59"
  //                   },
  //                   "11": {
  //                     "label": "December",
  //                     "key": "month",
  //                     "value": "december",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "12-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 },
  //                 "quarter": {
  //                   "0": {
  //                     "label": "Q1",
  //                     "key": "quarter",
  //                     "value": "Q1",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "Q2",
  //                     "key": "quarter",
  //                     "value": "Q2",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "Q3",
  //                     "key": "quarter",
  //                     "value": "Q3",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "Q4",
  //                     "key": "quarter",
  //                     "value": "Q4",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 }
  //               },
  //               "default_year_range": 0,
  //               "grid_style": {}
  //             },
  //             {
  //               "name": "Rejection By Reason - By Field & Office",
  //               "priority": 2,
  //               "tab_key": "rejection-by-reason-field-office",
  //               "req_body": {
  //                 "groups": [
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field",
  //                       "reason_rejection_base"
  //                     ],
  //                     "overall": {
  //                       "name": "OverallTotal",
  //                       "group": [
  //                         "reason_rejection_base"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "reason_rejection_base"
  //                         ],
  //                         "row": "Zone#Total",
  //                         "ignore_filters": [
  //                           "zone_field"
  //                         ],
  //                         "add_split_filters": [
  //                           {
  //                             "name": "zone_field",
  //                             "new_filter": "zone",
  //                             "index": 0,
  //                             "split": "#"
  //                           }
  //                         ]
  //                       }
  //                     ]
  //                   },
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field",
  //                       "total"
  //                     ],
  //                     "overall": {
  //                       "name": "OverallTotal",
  //                       "group": [
  //                         "total"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "total"
  //                         ],
  //                         "row": "Zone#Total"
  //                       }
  //                     ],
  //                     "ignore_filters": [
  //                       "reason_rejection",
  //                       "zone_field"
  //                     ],
  //                     "add_split_filters": [
  //                       {
  //                         "name": "zone_field",
  //                         "new_filter": "zone",
  //                         "index": 0,
  //                         "split": "#"
  //                       }
  //                     ]
  //                   },
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field",
  //                       "grand_total"
  //                     ],
  //                     "overall": {
  //                       "name": "OverallTotal",
  //                       "group": [
  //                         "grand_total"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "grand_total"
  //                         ],
  //                         "row": "Zone#Total"
  //                       }
  //                     ],
  //                     "ignore_filters": [
  //                       "reason_rejection",
  //                       "zone_field"
  //                     ],
  //                     "add_split_filters": [
  //                       {
  //                         "name": "zone_field",
  //                         "new_filter": "zone",
  //                         "index": 0,
  //                         "split": "#"
  //                       }
  //                     ]
  //                   }
  //                 ],
  //                 "row": "Zone#Field Office",
  //                 "col": "",
  //                 "percentage": [
  //                   "all"
  //                 ],
  //                 "formulas": [
  //                   {
  //                     "formula": [
  //                       "value",
  //                       "Total"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": true,
  //                     "type": "col"
  //                   }
  //                 ],
  //                 "hide_col": [
  //                   "grand_total"
  //                 ],
  //                 "required_filters": {
  //                   "Office": {
  //                     "name": "zone_field",
  //                     "type": "tree"
  //                   },
  //                   "Reasons": {
  //                     "name": "reason_rejection",
  //                     "type": "tree"
  //                   }
  //                 }
  //               },
  //               "filters": {
  //                 "frequency": {
  //                   "0": {
  //                     "label": "Yearly",
  //                     "key": "frequency",
  //                     "value": "Year",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "to": "year"
  //                     },
  //                     "selected": true,
  //                     "default_year_range": 0
  //                   },
  //                   "1": {
  //                     "label": "Quarterly",
  //                     "key": "frequency",
  //                     "value": "Quarter",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "quarter": "quarter"
  //                     },
  //                     "default_year_range": 0
  //                   },
  //                   "2": {
  //                     "label": "Monthly",
  //                     "key": "frequency",
  //                     "value": "Month",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "month": "month"
  //                     },
  //                     "default_year_range": 0
  //                   }
  //                 }
  //               },
  //               "year_filters": {
  //                 "from": "year",
  //                 "to": "year",
  //                 "month": {
  //                   "0": {
  //                     "label": "January",
  //                     "key": "month",
  //                     "value": "january",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "01-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "February",
  //                     "key": "month",
  //                     "value": "february",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "02-01  00:00:00",
  //                     "end": "02-28  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "March",
  //                     "key": "month",
  //                     "value": "march",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "03-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "April",
  //                     "key": "month",
  //                     "value": "april",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "04-30  23:59:59"
  //                   },
  //                   "4": {
  //                     "label": "May",
  //                     "key": "month",
  //                     "value": "may",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "05-01  00:00:00",
  //                     "end": "05-31  23:59:59"
  //                   },
  //                   "5": {
  //                     "label": "June",
  //                     "key": "month",
  //                     "value": "june",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "06-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "6": {
  //                     "label": "July",
  //                     "key": "month",
  //                     "value": "july",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "07-31  23:59:59"
  //                   },
  //                   "7": {
  //                     "label": "August",
  //                     "key": "month",
  //                     "value": "august",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "08-01  00:00:00",
  //                     "end": "08-31  23:59:59"
  //                   },
  //                   "8": {
  //                     "label": "September",
  //                     "key": "month",
  //                     "value": "sepetember",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "09-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "9": {
  //                     "label": "October",
  //                     "key": "month",
  //                     "value": "october",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "10-31  23:59:59"
  //                   },
  //                   "10": {
  //                     "label": "November",
  //                     "key": "month",
  //                     "value": "november",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "11-01  00:00:00",
  //                     "end": "11-30  23:59:59"
  //                   },
  //                   "11": {
  //                     "label": "December",
  //                     "key": "month",
  //                     "value": "december",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "12-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 },
  //                 "quarter": {
  //                   "0": {
  //                     "label": "Q1",
  //                     "key": "quarter",
  //                     "value": "Q1",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "Q2",
  //                     "key": "quarter",
  //                     "value": "Q2",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "Q3",
  //                     "key": "quarter",
  //                     "value": "Q3",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "Q4",
  //                     "key": "quarter",
  //                     "value": "Q4",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 }
  //               },
  //               "default_year_range": 0,
  //               "grid_style": {}
  //             },
  //             {
  //               "name": " Rejection Reason (%) - @ Office & Zonal level vs AI",
  //               "priority": 3,
  //               "tab_key": "rejection-reason-field-zonal-level-vs-ai",
  //               "req_body": {
  //                 "groups": [
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field",
  //                       "reason_rejection_base",
  //                       "total_base"
  //                     ],
  //                     "overall": {
  //                       "name": "OverallTotal",
  //                       "group": [
  //                         "reason_rejection_base",
  //                         "total_base"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "reason_rejection_base",
  //                           "total_base"
  //                         ],
  //                         "row": "Zone#Total",
  //                         "ignore_filters": [
  //                           "zone_field"
  //                         ],
  //                         "add_split_filters": [
  //                           {
  //                             "name": "zone_field",
  //                             "new_filter": "zone",
  //                             "index": 0,
  //                             "split": "#"
  //                           }
  //                         ]
  //                       }
  //                     ]
  //                   }
  //                 ],
  //                 "row": "Zone#Field Office",
  //                 "col": "",
  //                 "percentage": [
  //                   "all"
  //                 ],
  //                 "formulas": [
  //                   {
  //                     "formula": [
  //                       "value",
  //                       "OverallTotal"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": true,
  //                     "type": "row"
  //                   }
  //                 ],
  //                 "required_filters": {
  //                   "Office": {
  //                     "name": "zone_field",
  //                     "type": "tree"
  //                   },
  //                   "Reasons": {
  //                     "name": "reason_rejection",
  //                     "type": "tree"
  //                   }
  //                 }
  //               },
  //               "filters": {
  //                 "frequency": {
  //                   "0": {
  //                     "label": "Yearly",
  //                     "key": "frequency",
  //                     "value": "Year",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "to": "year"
  //                     },
  //                     "selected": true,
  //                     "default_year_range": 0
  //                   },
  //                   "1": {
  //                     "label": "Quarterly",
  //                     "key": "frequency",
  //                     "value": "Quarter",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "quarter": "quarter"
  //                     },
  //                     "default_year_range": 0
  //                   },
  //                   "2": {
  //                     "label": "Monthly",
  //                     "key": "frequency",
  //                     "value": "Month",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "month": "month"
  //                     },
  //                     "default_year_range": 0
  //                   }
  //                 }
  //               },
  //               "year_filters": {
  //                 "from": "year",
  //                 "to": "year",
  //                 "month": {
  //                   "0": {
  //                     "label": "January",
  //                     "key": "month",
  //                     "value": "january",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "01-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "February",
  //                     "key": "month",
  //                     "value": "february",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "02-01  00:00:00",
  //                     "end": "02-28  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "March",
  //                     "key": "month",
  //                     "value": "march",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "03-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "April",
  //                     "key": "month",
  //                     "value": "april",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "04-30  23:59:59"
  //                   },
  //                   "4": {
  //                     "label": "May",
  //                     "key": "month",
  //                     "value": "may",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "05-01  00:00:00",
  //                     "end": "05-31  23:59:59"
  //                   },
  //                   "5": {
  //                     "label": "June",
  //                     "key": "month",
  //                     "value": "june",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "06-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "6": {
  //                     "label": "July",
  //                     "key": "month",
  //                     "value": "july",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "07-31  23:59:59"
  //                   },
  //                   "7": {
  //                     "label": "August",
  //                     "key": "month",
  //                     "value": "august",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "08-01  00:00:00",
  //                     "end": "08-31  23:59:59"
  //                   },
  //                   "8": {
  //                     "label": "September",
  //                     "key": "month",
  //                     "value": "sepetember",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "09-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "9": {
  //                     "label": "October",
  //                     "key": "month",
  //                     "value": "october",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "10-31  23:59:59"
  //                   },
  //                   "10": {
  //                     "label": "November",
  //                     "key": "month",
  //                     "value": "november",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "11-01  00:00:00",
  //                     "end": "11-30  23:59:59"
  //                   },
  //                   "11": {
  //                     "label": "December",
  //                     "key": "month",
  //                     "value": "december",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "12-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 },
  //                 "quarter": {
  //                   "0": {
  //                     "label": "Q1",
  //                     "key": "quarter",
  //                     "value": "Q1",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "Q2",
  //                     "key": "quarter",
  //                     "value": "Q2",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "Q3",
  //                     "key": "quarter",
  //                     "value": "Q3",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "Q4",
  //                     "key": "quarter",
  //                     "value": "Q4",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 }
  //               },
  //               "default_year_range": 0,
  //               "grid_style": {}
  //             }
  //           ]
  //         },
  //         {
  //           "name": "Rejection by EIC",
  //           "sheet_key": "rejection-by-eic",
  //           "priority": 4,
  //           "tabs": [
  //             {
  //               "name": "Rejection % by EIC",
  //               "priority": 1,
  //               "tab_key": "rejection %-by-eic",
  //               "req_body": {
  //                 "groups": [
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field_eic",
  //                       "{{frequency}}_base",
  //                       "{{frequency}}_rejection %",
  //                       "{{frequency}}_rejection %_total"
  //                     ],
  //                     "order": [
  //                       "{{frequency}}"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "{{frequency}}_base",
  //                         "{{frequency}}_rejection %",
  //                         "{{frequency}}_rejection %_total"
  //                       ],
  //                       "ignore_filters": [
  //                         "zone_field_eic"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "{{frequency}}_base",
  //                           "{{frequency}}_rejection %",
  //                           "{{frequency}}_rejection %_total"
  //                         ],
  //                         "row": "Zone#Total",
  //                         "ignore_filters": [
  //                           "zone_field_eic"
  //                         ],
  //                         "add_split_filters": [
  //                           {
  //                             "name": "zone_field_eic",
  //                             "new_filter": "zone",
  //                             "index": 0,
  //                             "split": "#"
  //                           }
  //                         ]
  //                       }
  //                     ]
  //                   },
  //                   {
  //                     "data_from": "master_data_clt",
  //                     "group": [
  //                       "zone_field_eic",
  //                       "{{frequency}}_base",
  //                       "{{frequency}}_rejection %",
  //                       "{{frequency}}_rejection %_total"
  //                     ],
  //                     "order": [
  //                       "{{frequency}}"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "{{frequency}}_base",
  //                         "{{frequency}}_rejection %",
  //                         "{{frequency}}_rejection %_total"
  //                       ],
  //                       "ignore_filters": [
  //                         "zone_field_eic"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "{{frequency}}_base",
  //                           "{{frequency}}_rejection %",
  //                           "{{frequency}}_rejection %_total"
  //                         ],
  //                         "row": "Zone#Total",
  //                         "ignore_filters": [
  //                           "zone_field_eic"
  //                         ],
  //                         "add_split_filters": [
  //                           {
  //                             "name": "zone_field_eic",
  //                             "new_filter": "zone",
  //                             "index": 0,
  //                             "split": "#"
  //                           }
  //                         ]
  //                       }
  //                     ]
  //                   }
  //                 ],
  //                 "row": "Zone#Field Office#EIC",
  //                 "col": "",
  //                 "percentage": [
  //                   "Rejection %"
  //                 ],
  //                 "formulas": [
  //                   {
  //                     "formula": [
  //                       "value",
  //                       "{{value}}#Total"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": false,
  //                     "type": "col"
  //                   }
  //                 ],
  //                 "hide_col": [
  //                   "#Total"
  //                 ],
  //                 "trend": {
  //                   "compare_year": 1,
  //                   "col": "Rejection %"
  //                 },
  //                 "required_filters": {
  //                   "EIC": {
  //                     "name": "zone_field_eic",
  //                     "type": "tree"
  //                   }
  //                 }
  //               },
  //               "filters": {
  //                 "frequency": {
  //                   "0": {
  //                     "label": "Yearly",
  //                     "key": "frequency",
  //                     "value": "Year",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "to": "year"
  //                     },
  //                     "selected": true,
  //                     "default_year_range": 0
  //                   },
  //                   "1": {
  //                     "label": "Quarterly",
  //                     "key": "frequency",
  //                     "value": "Quarter",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year"
  //                     },
  //                     "default_year_range": 0
  //                   },
  //                   "2": {
  //                     "label": "Monthly",
  //                     "key": "frequency",
  //                     "value": "Month",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year"
  //                     },
  //                     "default_year_range": 0
  //                   }
  //                 }
  //               },
  //               "year_filters": {
  //                 "from": "year",
  //                 "to": "year",
  //                 "month": {
  //                   "0": {
  //                     "label": "January",
  //                     "key": "month",
  //                     "value": "january",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "01-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "February",
  //                     "key": "month",
  //                     "value": "february",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "02-01  00:00:00",
  //                     "end": "02-28  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "March",
  //                     "key": "month",
  //                     "value": "march",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "03-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "April",
  //                     "key": "month",
  //                     "value": "april",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "04-30  23:59:59"
  //                   },
  //                   "4": {
  //                     "label": "May",
  //                     "key": "month",
  //                     "value": "may",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "05-01  00:00:00",
  //                     "end": "05-31  23:59:59"
  //                   },
  //                   "5": {
  //                     "label": "June",
  //                     "key": "month",
  //                     "value": "june",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "06-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "6": {
  //                     "label": "July",
  //                     "key": "month",
  //                     "value": "july",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "07-31  23:59:59"
  //                   },
  //                   "7": {
  //                     "label": "August",
  //                     "key": "month",
  //                     "value": "august",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "08-01  00:00:00",
  //                     "end": "08-31  23:59:59"
  //                   },
  //                   "8": {
  //                     "label": "September",
  //                     "key": "month",
  //                     "value": "sepetember",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "09-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "9": {
  //                     "label": "October",
  //                     "key": "month",
  //                     "value": "october",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "10-31  23:59:59"
  //                   },
  //                   "10": {
  //                     "label": "November",
  //                     "key": "month",
  //                     "value": "november",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "11-01  00:00:00",
  //                     "end": "11-30  23:59:59"
  //                   },
  //                   "11": {
  //                     "label": "December",
  //                     "key": "month",
  //                     "value": "december",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "12-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 },
  //                 "quarter": {
  //                   "0": {
  //                     "label": "Q1",
  //                     "key": "quarter",
  //                     "value": "Q1",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "Q2",
  //                     "key": "quarter",
  //                     "value": "Q2",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "Q3",
  //                     "key": "quarter",
  //                     "value": "Q3",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "Q4",
  //                     "key": "quarter",
  //                     "value": "Q4",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 }
  //               },
  //               "default_year_range": 0,
  //               "grid_style": {}
  //             },
  //             {
  //               "name": "Rejection Reasons (%) by EIC",
  //               "priority": 2,
  //               "tab_key": "rejection-by-reason-by-eic",
  //               "req_body": {
  //                 "groups": [
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field_eic",
  //                       "reason_rejection_base"
  //                     ],
  //                     "overall": {
  //                       "name": "OverallTotal",
  //                       "group": [
  //                         "reason_rejection_base"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "reason_rejection_base"
  //                         ],
  //                         "row": "Zone#Total"
  //                       }
  //                     ]
  //                   },
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field_eic",
  //                       "total"
  //                     ],
  //                     "overall": {
  //                       "name": "OverallTotal",
  //                       "group": [
  //                         "total"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "total"
  //                         ],
  //                         "row": "Zone#Total"
  //                       }
  //                     ],
  //                     "ignore_filters": [
  //                       "reason_rejection"
  //                     ]
  //                   },
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field_eic",
  //                       "grand_total"
  //                     ],
  //                     "overall": {
  //                       "name": "OverallTotal",
  //                       "group": [
  //                         "grand_total"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "grand_total"
  //                         ],
  //                         "row": "Zone#Total"
  //                       }
  //                     ],
  //                     "ignore_filters": [
  //                       "reason_rejection"
  //                     ]
  //                   }
  //                 ],
  //                 "row": "Zone#Field Office#EIC",
  //                 "col": "",
  //                 "percentage": [
  //                   "all"
  //                 ],
  //                 "formulas": [
  //                   {
  //                     "formula": [
  //                       "value",
  //                       "Total"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": true,
  //                     "type": "col"
  //                   }
  //                 ],
  //                 "hide_col": [
  //                   "grand_total"
  //                 ],
  //                 "required_filters": {
  //                   "EIC": {
  //                     "name": "zone_field_eic",
  //                     "type": "tree"
  //                   },
  //                   "Reasons": {
  //                     "name": "reason_rejection",
  //                     "type": "tree"
  //                   }
  //                 }
  //               },
  //               "filters": {
  //                 "frequency": {
  //                   "0": {
  //                     "label": "Yearly",
  //                     "key": "frequency",
  //                     "value": "Year",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "to": "year"
  //                     },
  //                     "selected": true,
  //                     "default_year_range": 0
  //                   },
  //                   "1": {
  //                     "label": "Quarterly",
  //                     "key": "frequency",
  //                     "value": "Quarter",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "quarter": "quarter"
  //                     },
  //                     "default_year_range": 0
  //                   },
  //                   "2": {
  //                     "label": "Monthly",
  //                     "key": "frequency",
  //                     "value": "Month",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "month": "month"
  //                     },
  //                     "default_year_range": 0
  //                   }
  //                 }
  //               },
  //               "year_filters": {
  //                 "from": "year",
  //                 "to": "year",
  //                 "month": {
  //                   "0": {
  //                     "label": "January",
  //                     "key": "month",
  //                     "value": "january",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "01-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "February",
  //                     "key": "month",
  //                     "value": "february",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "02-01  00:00:00",
  //                     "end": "02-28  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "March",
  //                     "key": "month",
  //                     "value": "march",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "03-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "April",
  //                     "key": "month",
  //                     "value": "april",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "04-30  23:59:59"
  //                   },
  //                   "4": {
  //                     "label": "May",
  //                     "key": "month",
  //                     "value": "may",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "05-01  00:00:00",
  //                     "end": "05-31  23:59:59"
  //                   },
  //                   "5": {
  //                     "label": "June",
  //                     "key": "month",
  //                     "value": "june",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "06-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "6": {
  //                     "label": "July",
  //                     "key": "month",
  //                     "value": "july",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "07-31  23:59:59"
  //                   },
  //                   "7": {
  //                     "label": "August",
  //                     "key": "month",
  //                     "value": "august",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "08-01  00:00:00",
  //                     "end": "08-31  23:59:59"
  //                   },
  //                   "8": {
  //                     "label": "September",
  //                     "key": "month",
  //                     "value": "sepetember",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "09-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "9": {
  //                     "label": "October",
  //                     "key": "month",
  //                     "value": "october",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "10-31  23:59:59"
  //                   },
  //                   "10": {
  //                     "label": "November",
  //                     "key": "month",
  //                     "value": "november",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "11-01  00:00:00",
  //                     "end": "11-30  23:59:59"
  //                   },
  //                   "11": {
  //                     "label": "December",
  //                     "key": "month",
  //                     "value": "december",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "12-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 },
  //                 "quarter": {
  //                   "0": {
  //                     "label": "Q1",
  //                     "key": "quarter",
  //                     "value": "Q1",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "Q2",
  //                     "key": "quarter",
  //                     "value": "Q2",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "Q3",
  //                     "key": "quarter",
  //                     "value": "Q3",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "Q4",
  //                     "key": "quarter",
  //                     "value": "Q4",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 }
  //               },
  //               "default_year_range": 1,
  //               "grid_style": {}
  //             }
  //           ]
  //         },
  //         {
  //           "name": "Rejection by Interviewer",
  //           "sheet_key": "rejection-by-interviewer",
  //           "priority": 5,
  //           "tabs": [
  //             {
  //               "name": "Interviewer wise Rejection %",
  //               "priority": 1,
  //               "tab_key": "interviewer-wise-rejection",
  //               "req_body": {
  //                 "groups": [
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "login",
  //                       "{{frequency}}_base",
  //                       "{{frequency}}_rejection %",
  //                       "{{frequency}}_rejection %_total"
  //                     ],
  //                     "order": [
  //                       "{{frequency}}"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "{{frequency}}_base",
  //                         "{{frequency}}_rejection %",
  //                         "{{frequency}}_rejection %_total"
  //                       ]
  //                     }
  //                   },
  //                   {
  //                     "data_from": "master_data_clt",
  //                     "group": [
  //                       "login",
  //                       "{{frequency}}_base",
  //                       "{{frequency}}_rejection %",
  //                       "{{frequency}}_rejection %_total"
  //                     ],
  //                     "order": [
  //                       "{{frequency}}"
  //                     ],
  //                     "overall": {
  //                       "name": "National",
  //                       "group": [
  //                         "{{frequency}}_base",
  //                         "{{frequency}}_rejection %",
  //                         "{{frequency}}_rejection %_total"
  //                       ]
  //                     }
  //                   }
  //                 ],
  //                 "row": "Interviewer",
  //                 "col": "",
  //                 "percentage": [
  //                   "Rejection %"
  //                 ],
  //                 "formulas": [
  //                   {
  //                     "formula": [
  //                       "value",
  //                       "{{value}}#Total"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": false,
  //                     "type": "col"
  //                   }
  //                 ],
  //                 "hide_col": [
  //                   "#Total"
  //                 ],
  //                 "trend": {
  //                   "compare_year": 1,
  //                   "col": "Rejection %"
  //                 },
  //                 "required_filters": {
  //                   "Interviewer": {
  //                     "name": "login",
  //                     "type": "tree"
  //                   }
  //                 }
  //               },
  //               "filters": {
  //                 "frequency": {
  //                   "0": {
  //                     "label": "Yearly",
  //                     "key": "frequency",
  //                     "value": "Year",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "to": "year"
  //                     },
  //                     "selected": true,
  //                     "default_year_range": 0
  //                   },
  //                   "1": {
  //                     "label": "Quarterly",
  //                     "key": "frequency",
  //                     "value": "Quarter",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year"
  //                     },
  //                     "default_year_range": 0
  //                   },
  //                   "2": {
  //                     "label": "Monthly",
  //                     "key": "frequency",
  //                     "value": "Month",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year"
  //                     },
  //                     "default_year_range": 0
  //                   }
  //                 }
  //               },
  //               "year_filters": {
  //                 "from": "year",
  //                 "to": "year",
  //                 "month": {
  //                   "0": {
  //                     "label": "January",
  //                     "key": "month",
  //                     "value": "january",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "01-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "February",
  //                     "key": "month",
  //                     "value": "february",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "02-01  00:00:00",
  //                     "end": "02-28  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "March",
  //                     "key": "month",
  //                     "value": "march",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "03-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "April",
  //                     "key": "month",
  //                     "value": "april",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "04-30  23:59:59"
  //                   },
  //                   "4": {
  //                     "label": "May",
  //                     "key": "month",
  //                     "value": "may",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "05-01  00:00:00",
  //                     "end": "05-31  23:59:59"
  //                   },
  //                   "5": {
  //                     "label": "June",
  //                     "key": "month",
  //                     "value": "june",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "06-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "6": {
  //                     "label": "July",
  //                     "key": "month",
  //                     "value": "july",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "07-31  23:59:59"
  //                   },
  //                   "7": {
  //                     "label": "August",
  //                     "key": "month",
  //                     "value": "august",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "08-01  00:00:00",
  //                     "end": "08-31  23:59:59"
  //                   },
  //                   "8": {
  //                     "label": "September",
  //                     "key": "month",
  //                     "value": "sepetember",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "09-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "9": {
  //                     "label": "October",
  //                     "key": "month",
  //                     "value": "october",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "10-31  23:59:59"
  //                   },
  //                   "10": {
  //                     "label": "November",
  //                     "key": "month",
  //                     "value": "november",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "11-01  00:00:00",
  //                     "end": "11-30  23:59:59"
  //                   },
  //                   "11": {
  //                     "label": "December",
  //                     "key": "month",
  //                     "value": "december",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "12-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 },
  //                 "quarter": {
  //                   "0": {
  //                     "label": "Q1",
  //                     "key": "quarter",
  //                     "value": "Q1",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "Q2",
  //                     "key": "quarter",
  //                     "value": "Q2",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "Q3",
  //                     "key": "quarter",
  //                     "value": "Q3",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "Q4",
  //                     "key": "quarter",
  //                     "value": "Q4",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 }
  //               },
  //               "default_year_range": 0,
  //               "grid_style": {}
  //             },
  //             {
  //               "name": "Rejection Reasons % by Interviewer",
  //               "priority": 2,
  //               "tab_key": "rejection-by-reason-by-interviewer",
  //               "req_body": {
  //                 "groups": [
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field",
  //                       "reason_rejection_base"
  //                     ],
  //                     "overall": {
  //                       "name": "OverallTotal",
  //                       "group": [
  //                         "reason_rejection_base"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "reason_rejection_base"
  //                         ],
  //                         "row": "Zone#Total"
  //                       }
  //                     ]
  //                   },
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field",
  //                       "total"
  //                     ],
  //                     "overall": {
  //                       "name": "OverallTotal",
  //                       "group": [
  //                         "total"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "total"
  //                         ],
  //                         "row": "Zone#Total"
  //                       }
  //                     ],
  //                     "ignore_filters": [
  //                       "reason_rejection"
  //                     ]
  //                   },
  //                   {
  //                     "data_from": "master_data_base",
  //                     "group": [
  //                       "zone_field",
  //                       "grand_total"
  //                     ],
  //                     "overall": {
  //                       "name": "OverallTotal",
  //                       "group": [
  //                         "grand_total"
  //                       ]
  //                     },
  //                     "totals": [
  //                       {
  //                         "group": [
  //                           "zone_total",
  //                           "grand_total"
  //                         ],
  //                         "row": "Zone#Total"
  //                       }
  //                     ],
  //                     "ignore_filters": [
  //                       "reason_rejection"
  //                     ]
  //                   }
  //                 ],
  //                 "row": "Zone#Field Office",
  //                 "col": "",
  //                 "percentage": [
  //                   "all"
  //                 ],
  //                 "formulas": [
  //                   {
  //                     "formula": [
  //                       "value",
  //                       "Total"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": false,
  //                     "type": "col"
  //                   },
  //                   {
  //                     "formula": [
  //                       "Total",
  //                       "grand_total"
  //                     ],
  //                     "operators": [
  //                       "/",
  //                       "*100"
  //                     ],
  //                     "self": false,
  //                     "type": "col"
  //                   }
  //                 ],
  //                 "hide_col": [
  //                   "grand_total"
  //                 ],
  //                 "required_filters": {
  //                   "Office": {
  //                     "name": "zone_field",
  //                     "type": "tree"
  //                   },
  //                   "Reasons": {
  //                     "name": "reason_rejection",
  //                     "type": "tree"
  //                   }
  //                 }
  //               },
  //               "filters": {
  //                 "frequency": {
  //                   "0": {
  //                     "label": "Yearly",
  //                     "key": "frequency",
  //                     "value": "Year",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "to": "year"
  //                     },
  //                     "selected": true,
  //                     "default_year_range": 0
  //                   },
  //                   "1": {
  //                     "label": "Quarterly",
  //                     "key": "frequency",
  //                     "value": "Quarter",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "quarter": "quarter"
  //                     },
  //                     "default_year_range": 0
  //                   },
  //                   "2": {
  //                     "label": "Monthly",
  //                     "key": "frequency",
  //                     "value": "Month",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "year_filters": {
  //                       "from": "year",
  //                       "month": "month"
  //                     },
  //                     "default_year_range": 0
  //                   }
  //                 }
  //               },
  //               "year_filters": {
  //                 "from": "year",
  //                 "to": "year",
  //                 "month": {
  //                   "0": {
  //                     "label": "January",
  //                     "key": "month",
  //                     "value": "january",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "01-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "February",
  //                     "key": "month",
  //                     "value": "february",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "02-01  00:00:00",
  //                     "end": "02-28  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "March",
  //                     "key": "month",
  //                     "value": "march",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "03-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "April",
  //                     "key": "month",
  //                     "value": "april",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "04-30  23:59:59"
  //                   },
  //                   "4": {
  //                     "label": "May",
  //                     "key": "month",
  //                     "value": "may",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "05-01  00:00:00",
  //                     "end": "05-31  23:59:59"
  //                   },
  //                   "5": {
  //                     "label": "June",
  //                     "key": "month",
  //                     "value": "june",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "06-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "6": {
  //                     "label": "July",
  //                     "key": "month",
  //                     "value": "july",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "07-31  23:59:59"
  //                   },
  //                   "7": {
  //                     "label": "August",
  //                     "key": "month",
  //                     "value": "august",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "08-01  00:00:00",
  //                     "end": "08-31  23:59:59"
  //                   },
  //                   "8": {
  //                     "label": "September",
  //                     "key": "month",
  //                     "value": "sepetember",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "09-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "9": {
  //                     "label": "October",
  //                     "key": "month",
  //                     "value": "october",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "10-31  23:59:59"
  //                   },
  //                   "10": {
  //                     "label": "November",
  //                     "key": "month",
  //                     "value": "november",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "11-01  00:00:00",
  //                     "end": "11-30  23:59:59"
  //                   },
  //                   "11": {
  //                     "label": "December",
  //                     "key": "month",
  //                     "value": "december",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "12-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 },
  //                 "quarter": {
  //                   "0": {
  //                     "label": "Q1",
  //                     "key": "quarter",
  //                     "value": "Q1",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "01-01  00:00:00",
  //                     "end": "03-31  23:59:59"
  //                   },
  //                   "1": {
  //                     "label": "Q2",
  //                     "key": "quarter",
  //                     "value": "Q2",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "04-01  00:00:00",
  //                     "end": "06-30  23:59:59"
  //                   },
  //                   "2": {
  //                     "label": "Q3",
  //                     "key": "quarter",
  //                     "value": "Q3",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "07-01  00:00:00",
  //                     "end": "09-30  23:59:59"
  //                   },
  //                   "3": {
  //                     "label": "Q4",
  //                     "key": "quarter",
  //                     "value": "Q4",
  //                     "type": "radio",
  //                     "selection": "string",
  //                     "start": "10-01  00:00:00",
  //                     "end": "12-31  23:59:59"
  //                   }
  //                 }
  //               },
  //               "default_year_range": 1,
  //               "grid_style": {}
  //             }
  //           ]
  //         }
  //       ],
  //       "dashboard": {
  //         "required_filters": {
  //           "year": {
  //             "name": "year",
  //             "type": "radio"
  //           }
  //         },
  //         "graphs": {
  //           "year": {
  //             "req_body": {
  //               "groups": [
  //                 {
  //                   "data_from": "master_data_base",
  //                   "group": [
  //                     "year",
  //                     "total_count",
  //                     "count_total"
  //                   ]
  //                 },
  //                 {
  //                   "data_from": "master_data_clt",
  //                   "group": [
  //                     "year",
  //                     "total_count",
  //                     "count_total"
  //                   ]
  //                 }
  //               ],
  //               "col": "year",
  //               "row": "",
  //               "percentage": [
  //                 "all"
  //               ],
  //               "formulas": [
  //                 {
  //                   "formula": [
  //                     "value",
  //                     "{{value}}#Total"
  //                   ],
  //                   "operators": [
  //                     "/",
  //                     "*100"
  //                   ],
  //                   "self": false,
  //                   "type": "col"
  //                 }
  //               ],
  //               "hide_col": [
  //                 "#Total"
  //               ]
  //             }
  //           },
  //           "month": {
  //             "req_body": {
  //               "groups": [
  //                 {
  //                   "data_from": "master_data_base",
  //                   "group": [
  //                     "month",
  //                     "total_count",
  //                     "month_total"
  //                   ],
  //                   "order": [
  //                     "month"
  //                   ]
  //                 },
  //                 {
  //                   "data_from": "master_data_clt",
  //                   "group": [
  //                     "month",
  //                     "total_count",
  //                     "month_total"
  //                   ],
  //                   "order": [
  //                     "month"
  //                   ]
  //                 }
  //               ],
  //               "col": "month",
  //               "row": "",
  //               "percentage": [
  //                 "all"
  //               ],
  //               "formulas": [
  //                 {
  //                   "formula": [
  //                     "value",
  //                     "{{value}}#Total"
  //                   ],
  //                   "operators": [
  //                     "/",
  //                     "*100"
  //                   ],
  //                   "self": false,
  //                   "type": "col"
  //                 }
  //               ],
  //               "hide_col": [
  //                 "#Total"
  //               ]
  //             }
  //           },
  //           "zones": {
  //             "req_body": {
  //               "groups": [
  //                 {
  //                   "data_from": "master_data_base",
  //                   "group": [
  //                     "base_zone",
  //                     "total_count",
  //                     "base_zone_total"
  //                   ],
  //                   "order": [
  //                     "base_zone"
  //                   ]
  //                 },
  //                 {
  //                   "data_from": "master_data_clt",
  //                   "group": [
  //                     "base_zone",
  //                     "total_count",
  //                     "base_zone_total"
  //                   ],
  //                   "order": [
  //                     "base_zone"
  //                   ]
  //                 }
  //               ],
  //               "col": "zone",
  //               "row": "",
  //               "percentage": [
  //                 "all"
  //               ],
  //               "formulas": [
  //                 {
  //                   "formula": [
  //                     "value",
  //                     "{{value}}#Total"
  //                   ],
  //                   "operators": [
  //                     "/",
  //                     "*100"
  //                   ],
  //                   "self": false,
  //                   "type": "col"
  //                 }
  //               ],
  //               "hide_col": [
  //                 "#Total"
  //               ]
  //             }
  //           },
  //           "offices": {
  //             "req_body": {
  //               "groups": [
  //                 {
  //                   "data_from": "master_data_base",
  //                   "group": [
  //                     "office_zone",
  //                     "total_count",
  //                     "office_zone_total"
  //                   ],
  //                   "order": [
  //                     "zone"
  //                   ]
  //                 },
  //                 {
  //                   "data_from": "master_data_clt",
  //                   "group": [
  //                     "office_zone",
  //                     "total_count",
  //                     "office_zone_total"
  //                   ],
  //                   "order": [
  //                     "zone"
  //                   ]
  //                 }
  //               ],
  //               "col": "office_zone",
  //               "row": "",
  //               "percentage": [
  //                 "all"
  //               ],
  //               "formulas": [
  //                 {
  //                   "formula": [
  //                     "value",
  //                     "{{value}}#Total"
  //                   ],
  //                   "operators": [
  //                     "/",
  //                     "*100"
  //                   ],
  //                   "self": false,
  //                   "type": "col"
  //                 }
  //               ],
  //               "hide_col": [
  //                 "#Total"
  //               ]
  //             }
  //           }
  //         },
  //         "filters": {
  //           "year": {
  //             "0": {
  //               "label": 2022,
  //               "key": "year",
  //               "value": 2022,
  //               "type": "radio",
  //               "selection": "string"
  //             },
  //             "1": {
  //               "label": 2023,
  //               "key": "year",
  //               "value": 2023,
  //               "type": "radio",
  //               "selection": "string"
  //             },
  //             "2": {
  //               "label": 2024,
  //               "key": "year",
  //               "value": 2024,
  //               "type": "radio",
  //               "selection": "string"
  //             }
  //           }
  //         }
  //       }
  //     }
  //   }

  //   this.qaDashboardConfig = data['result']['dashboard'];
  //   this.qaReportConfig = data['result']['file_config'];
    
  // }
  setQaReportConfig(){
    this.getQaReportConfig().subscribe(data => {
      if(data['status'] == 1){
        this.qaDashboardConfig = data['result']['dashboard'] ? data['result']['dashboard'] : {}
        this.qaReportConfig = data['result']['file_config'] ? data['result']['file_config'] : {};
        // this.dummyConfig()
        this.initSideDrawerEvent.emit('qa-report');
      }else{
        this.notifier.notify("error",'Something went wrong');
      }
    });
  }

  reSetQaReportConfig(){
    this.getQaReportConfig().subscribe(data => {
      if(data['status'] == 1){
        this.qaDashboardConfig = data['result']['dashboard'] ? data['result']['dashboard'] : {}
        this.qaReportConfig = data['result']['file_config'] ? data['result']['file_config'] : {};
        // this.dummyConfig()
        this.initQaDashBoardConfigEmitter.emit();
      }else{
        this.notifier.notify("error",'Something went wrong');
      }
    });
  }

 

  applyFilter(qa_type?:string){
      if(this.checkForFilter()){;
        this.gridDataContainer = [];
        this.bufferArr = [];
        let body = this.selectedTab['req_body']
        body["filters"] = this.appliedFilter;
        this.reportFiltersCopy = [];
        this.reportFiltersCopy = JSON.parse(JSON.stringify(this.reportFilters));
        if (this.appliedFilter && this.appliedFilter['frequency'] && this.appliedFilter['frequency'].length) {
          let frequencyCheck = JSON.stringify(body)
          const updatedDataString = frequencyCheck.replace(/{{frequency}}/g, this.appliedFilter['frequency'][0]);
          body = JSON.parse(updatedDataString);
          if (this.appliedFilter['frequency'][0].toLowerCase() == "month") {
            delete body['trend'];
          }
        }
        this.isLoadingGridData = true;
        // console.log("body ===> ",body)
        this.getReportGrid(body);
 
      }
 
    // this.onApplyFilterEvent.emit({"filter":true})
  }

  checkForFilter(){
    if(Object.keys(this.appliedFilter).length){
      let isDateValid = true;
      Object.keys(this.appliedFilter).forEach(key =>{
        if(!this.appliedFilter[key].length){
          delete this.appliedFilter[key];
        }
        if(key === 'date'){
          if(this.appliedFilter[key]){
            this.appliedFilter[key].forEach(va =>{
              if(!va){
                this.notifier.notify('error','Please Select Start or End Date');
                isDateValid = false;
                return;
              }
            })
          }
        }
      })
      return Object.keys(this.appliedFilter).length && isDateValid ? true : false;
    }else{
      return false;
    }
  }
  firstLetterCapitalizer(str: string){
    if (!str) return str;
    let tempStrArr = str.split(" ")
    let newStr = "";
    tempStrArr.forEach(strItem => {
      newStr = newStr + strItem.charAt(0).toUpperCase() + strItem.slice(1).toLowerCase() + " "
    });
    return newStr;
  }
  

    transformData(input)  {
      this.reportFilters = [];
      Object.keys(input).forEach(filterKey => {
          if (input[filterKey]['0']['type'] === 'tree') {
            let tempFilter = {};
            tempFilter['key'] = input[filterKey]['0']['key'];
            tempFilter['fkey'] = filterKey;
            tempFilter["value"] = input[filterKey];
            tempFilter["type"] = input[filterKey]['0']['type'];
            tempFilter["options"] = [];
            tempFilter["selectedOptions"] = [];
            tempFilter["show"] = true;
            const root = {
              id: "all",
              name: "All",
              parent: "root",
              value: "root",
              children: []
            };
          
            const jobData = input[filterKey];
          
            for (const key in jobData) {
              if (jobData.hasOwnProperty(key)) {
                const item = jobData[key];
                if (item.value && item.value === "all") continue;
                item.value = item.value ? item.value + '' : '';
                const parts = item.value.split("#");
                let currentLevel = root;
          
                parts.forEach((part, index) => {
                  let existingChild = currentLevel.children.find(child => child.name === part);
          
                  if (!existingChild) {
                    existingChild = {
                      id: `${currentLevel.id}#${part}`,
                      name: part,
                      parent: currentLevel.id,
                      value: `${currentLevel.id}#${part}`.replace('all#', ''),
                      children: []
                    };
                    currentLevel.children.push(existingChild);
                  }
          
                  currentLevel = existingChild;
                });
              }
            }
            // this.gridTreeFilters[filterKey]['options'].push(root);
            tempFilter['options'].push(root);
            this.reportFilters.push(tempFilter);
          } else if (input[filterKey]['0']['type'] === 'radio') {
            let tempFilter = {};
            tempFilter['key'] = input[filterKey]['0']['key'];
            tempFilter['fkey'] = filterKey;
            tempFilter["value"] = input[filterKey];
            tempFilter["type"] = input[filterKey]['0']['type'];
            tempFilter["selectedOption"] = tempFilter['fkey'] ==='frequency' ? this.defaultGraphFrequency : tempFilter['fkey'] ==='from' ? this.defaultReportDate.startDate : tempFilter['fkey'] ==='to' ? this.defaultReportDate.endDate :'';
            // tempFilter["selectedOption"] = input[filterKey]['0']['key'] ==='frequency' ? this.defaultGraphFrequency : '';
            tempFilter["show"] = (input[filterKey]['0']['visibility'] && input[filterKey]['0']['visibility'] == "hidden") ? false : true;
            // tempFilter["show"] = true;
            this.reportFilters.push(tempFilter);
          }else{
            let tempFilter = {};
            tempFilter['key'] = input[filterKey]['0']['key'];
            tempFilter['fkey'] = filterKey;
            tempFilter["value"] = input[filterKey];
            tempFilter["type"] = input[filterKey]['0']['type'];
            tempFilter["selectedOptions"] = [];
            // tempFilter["show"] = true;
            tempFilter["show"] = (input[filterKey]['0']['visibility'] && input[filterKey]['0']['visibility'] == "hidden") ? false : true;
            this.reportFilters.push(tempFilter);
          };
      });

      // console.log("this.reportFilters ===> ",this.reportFilters)
      this.reportFiltersCopy.forEach((filter,index) => {
        if (filter["type"] == "radio") {
          this.reportFilters[index]['selectedOption'] = JSON.parse(JSON.stringify(filter['selectedOption']));
        }else{
          this.reportFilters[index]['selectedOptions'] = JSON.parse(JSON.stringify(filter['selectedOptions']));
        }
        this.reportFilters[index]['show'] = JSON.parse(JSON.stringify(filter['show']));
      });
      // Object.keys(this.gridTreeFilterCopy).forEach(fKey => {
      //   this.gridTreeFilters[fKey]['selectedOptions'] = JSON.parse(JSON.stringify(this.gridTreeFilterCopy[fKey]['selectedOptions']));
      // });
    }

  
}
